/**
 * Created by forbiz on 2019-02-11.
 */

const DisplayList = () => {
    
    const banner_slider = () => {
        hdFn.hdSlide('.displayList .banner-area .slider', {
            arrows: true,
            autoplay: true,
            autoplaySpeed: 3000,						// 5초에 한 번
            cssEase: 'linear',
            dots:true,
            appendDots: $(".slick-controller"),
            fade: true,
            infinite: true,
            speed: 500,								// 루프 실행 속도
        });

        if ( $('.slider__list').length <= 1 ) {
            $('.slick-controller').hide();
        }
    };

    const DisplayList_init = () => {
        banner_slider();
    };

    DisplayList_init();
};

export default DisplayList;